import { inject, observer } from 'mobx-react';

import AcknowledgeAction from './controls/acknowledge-action';
import CloneAction from './controls/clone-action';
import EditAction from './controls/edit-action';
import React from 'react';
import { computed } from 'mobx';

@inject('vm')
@observer
class NormalActions extends React.Component {
  render() {
    if (!this.show) return null;

    return (
      <div>
        <EditAction onEdit={this.props.onEdit} />
        <AcknowledgeAction />
        <CloneAction />
      </div>
    );
  }

  @computed
  get show() {
    let { status, report } = this.props.vm;
    return status === 'normal' && !!report;
  }
}

NormalActions.defaultProps = {
  onEdit: () => {}
};

export default NormalActions;
